module.exports = __webpack_public_path__ + "281212cb0a93ecc294cfbc02e22ffdd2.svg";